module.exports = require("@asseinfo/react-kanban/dist/styles.css");